// import { useUserQuery } from 'auth/hooks'
// import { isLoggedInQuerySelector } from 'auth/selectors'
// import { keepPreviousData } from '@tanstack/react-query'

export function useShowCoins() {
  // const { data: isLoggedIn } = useUserQuery(undefined, {
  //   placeholderData: keepPreviousData,s
  //   select: isLoggedInQuerySelector,
  // })

  return false
}
